import * as Actions from './constants';

export const setStatsTableOpen = (value) => async (dispatch) => {
  dispatch({
    type: Actions.SET_STATS_TABLE,
    payload: value,
  });
};
